const decodeFilters = () => {
  const searchString = window.location.search.replace(
    '?',
    ''
  )

  const arrayParams = searchString.split('&')

  const initialTags: Record<string, string[]> = {}
  const initialProperties: Record<string, string[]> = {}
  let initialSort: string = ''
  const initialPrice: number[] = []

  arrayParams.forEach((param) => {
    const filter = param.split('=')
    const regExGetBetweenBrackets = /\[(.*?)\]/g
    const regExGetProperty = /(.*)_/g

    if (filter[0].includes('type_tags')) {
      const match = regExGetBetweenBrackets.exec(filter[0])
      if (match != null && match.length > 1) {
        const tagType = match[1]
        if (!initialTags[tagType]) initialTags[tagType] = []
        initialTags[tagType].push(filter[1].replace('%26', '&'))
      }
    }

    if (filter[0].includes('property')) {
      const match = regExGetProperty.exec(filter[0])
      if (match != null && match.length > 1) {
        const propertyName = match[1]
        if (!initialProperties[propertyName]) initialProperties[propertyName] = []
        initialProperties[propertyName].push(decodeURI(filter[1]).replace(/%26/g, '&').replace(/%23/g, '#').replace(/%7C/g, '|'))
      }
    }

    if (filter[0].includes('sort')) {
      initialSort = filter[1]
    }

    if (filter[0].includes('min_price')) {
      initialPrice[0] = parseFloat(filter[1])
    }

    if (filter[0].includes('max_price')) {
      initialPrice[1] = parseFloat(filter[1])
    }
  })

  return { initialTags, initialProperties, initialSort, initialPrice }
}

export default decodeFilters
